module.exports = __webpack_public_path__ + "static/media/Medcare Medical Centre Discovery Gardens.dee3e8fc.jpg";